module.exports = __webpack_public_path__ + "img/106043.76872700.png";